import { ALLERGEN_ICONS } from "../lib/venue-menus-client/menuItemConstants"

const AllergenIcon = ({ field, size = 18, className = "" }) => (
  <span
    className={`allergen-icon ${className}`.trim()}
    style={{ fontSize: size, lineHeight: 1 }}
    aria-hidden="true"
  >
    {ALLERGEN_ICONS[field] || "⚠️"}
  </span>
)

export default AllergenIcon
